const dashboardTypes = {
  SET_FILTERS: 'SET_FILTERS',
  SET_USAGEFILTERS: 'SET_USAGEFILTERS',
  SET_TABLE_FILTERS: 'SET_TABLE_FILTERS',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  SET_DOWNLOAD: 'SET_DOWNLOAD',
  SET_LOADING: 'SET_LOADING',
}

export default dashboardTypes
